import { FlexCenVer } from '@/UI/styles';
import { EL_COLORS } from '@/colors';
import { CreditsInfo } from '../FlowComponents/CreditsInfo/CreditsInfo';

export function DrawerHeader() {
  return (
    <FlexCenVer
      data-testid="properties-title"
      sx={{
        borderBottom: `1px solid ${EL_COLORS.BoxBorder}`,
        pl: 1.5,
        pr: 2,
        height: '84px',
      }}
    >
      <CreditsInfo isPaperBg={false} />
    </FlexCenVer>
  );
}
